import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileExportLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.5858 2C14.0573 2 14.5116 2.16649 14.8702 2.46691L15 2.58579L19.4142 7C19.7476 7.3334 19.9511 7.77238 19.9923 8.23836L20 8.41421V12H18V10H13.5C12.7203 10 12.0796 9.40511 12.0069 8.64446L12 8.5V4H6V20H12V22H6C4.94564 22 4.08183 21.1841 4.00549 20.1493L4 20V4C4 2.94564 4.81588 2.08183 5.85074 2.00549L6 2H13.5858ZM18.707 14.4645L21.5355 17.2929C21.926 17.6834 21.926 18.3166 21.5355 18.7071L18.707 21.5355C18.3165 21.9261 17.6834 21.9261 17.2928 21.5355C16.9023 21.145 16.9023 20.5118 17.2928 20.1213L18.4142 19H14C13.4477 19 13 18.5523 13 18C13 17.4477 13.4477 17 14 17H18.4142L17.2928 15.8787C16.9023 15.4882 16.9023 14.855 17.2928 14.4645C17.6834 14.0739 18.3165 14.0739 18.707 14.4645ZM14 4.41421V8H17.5858L14 4.41421Z"
	})
});
export default SvgFileExportLine;
